import { useState } from 'react';
import type React from 'react';
import { t } from 'i18next';
import { MenuDropdown, MenuDropdownItem } from '../../components/popup/MenuDropdown';

interface DeleteMenuDropdownProps {
  trigger: React.ReactNode;
  dropdownClassName: string;
  onDelete: () => void | Promise<void>;
  triggerAriaLabel?: string;
  stopPropagationOnMouseDown?: boolean;
  menuItemLabel?: string;
}

export const DeleteMenuDropdown = ({
  trigger,
  dropdownClassName,
  onDelete,
  triggerAriaLabel = t('SceneCommentsDetail.openMenu') as string,
  stopPropagationOnMouseDown = false,
  menuItemLabel = t('SceneCommentsDetail.delete') as string
}: DeleteMenuDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label={triggerAriaLabel}
        onMouseDown={stopPropagationOnMouseDown ? (e) => e.stopPropagation() : undefined}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {trigger}
      </button>
      {isOpen && (
        <MenuDropdown className={dropdownClassName} onClickOutside={() => setIsOpen(false)}>
          <MenuDropdownItem onClick={onDelete}>{menuItemLabel}</MenuDropdownItem>
        </MenuDropdown>
      )}
    </>
  );
};
